module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-19-407b9b6f3df756013ea35ae17c99b6a8.png";